var Common = {
  //todo investigate whether to use a proper code tree generator
  indentation: '  '
}
Common.indentationX2 = Common.indentation + Common.indentation;

export default Common;



// WEBPACK FOOTER //
// ./src/generators/common.js